import o from "./highrise647.mjs";
import e from "./highrise1583.mjs";
import i from "./highrise1584.mjs";
function n(t, r) {
  return i(e(t, r, o), t + "");
}
export {
  n as default
};
